var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omapi-tabnav"},_vm._l((_vm.tabs),function(tab,slug){return _c('div',{key:slug,staticClass:"omapi-tabnav__item",class:{ 'omapi-tabnav__item-active': _vm.isActive(slug) },on:{"click":function($event){return _vm.goTo(tab.route)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }